export default __webpack_public_path__ + "static/media/bar.ccd480c2.png";